module.exports = __webpack_public_path__ + "assets/989b8ef113377c89f56bcacf1e2f005f.mp3";